import React from 'react';
import classnames from 'classnames';
import ReactGA from 'react-ga';

import Toggle from '../common/Toggle';
import Customization from './customization';
import Loading from '../common/Loading';
import utils from '../../lib/utils';
import './index.scss';

class VoiceAIConfig extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggle: false,
      modalopen: false,
      showsucess: false,
      showFailure: false,
      showsucessemail: false,
    };
    this.conversationslist = [];
  }

  componentDidMount = () => {
    ReactGA.pageview(window.location.hash);
    ReactGA.event({
      category: 'User',
      action: 'Click on Voice AI Tab',
      label: 'Voice AI Page'
    });
    const features = utils.getCookie('features');
    if (features && features.includes('INCOMING_VOICE_LIVE')) {
      console.log('INCOMING_VOICE_LIVE', features.includes('INCOMING_VOICE_LIVE'))
      this.setState({
        toggle: true,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    
    if (nextProps.voiceaiconfig.updatingWeavePhone !== true && nextProps.voiceaiconfig.updatingWeavePhone !== this.props.voiceaiconfig.updatingWeavePhone) {
      this.props.getBookingSoftware();
      if (!nextProps.voiceaiconfig.updateWeavePhoneFail) {
        this.setState({
          showsucess: true
        })
        setTimeout(() => { this.setState({ showsucess: false }) }, 3000)
      } else {
        this.setState({
          showFailure: true
        })
        setTimeout(() => { this.setState({ showFailure: false }) }, 3000)
      }
    }
    // if (!nextProps.webbookingconfig.getEmailInst && nextProps.webbookingconfig.getEmailInst !== this.props.webbookingconfig.getEmailInst) {
    //   this.setState({
    //     showsucessemail: true
    //   })
    //   setTimeout(() => { this.setState({ showsucessemail: false }) }, 3000)
    // }
  }
  
  componentWillUnmount() {
    this.props.clearVoiceErrorMessage();
  }
  ToggleButton = (event) => {
    console.log(event.target.value);
    this.setState({
      toggle: !this.state.toggle
    }, this.props.updateVoiceStatus((!this.state.toggle) ? 'ENABLED' : 'DISABLED'));
  }
  ValueofToggle = (value) => {
    if (value) {
      return 'ENABLED';
    } else {
      return 'DISABLED';
    }

  }
  
  ValueofSubheading = (value) => {
    if (value) {
      return 'TrueLark powered Voice AI is active on your site';
    } else {
      return 'TrueLark powered Voice AI is not active on your site'
    }
  }
  
  IsConfigComplete = () => {
    const { softwares } = this.props;
    const info = softwares?.info;

    const phoneNumber = info?.weave_phones?.[0]?.id ?? '';
    const externalId = info?.external_id ?? '';

    return Boolean(phoneNumber && externalId);
  };


  render() {
    const { toggle, showsucess, showFailure } = this.state;
    const { voiceaiconfig, softwares } = this.props;
    const features = utils.getCookie('features');
    const isSetupComplete = this.IsConfigComplete(); 
    console.log('softwares', softwares.getSoftwares, isSetupComplete);
    return (
      <div className="webchat">
        {(voiceaiconfig.updatingWeavePhone || softwares.getSoftwares) &&
        <div className="add-campaign_loader">
        <Loading />
        </div>
        } 
        {
          <>
            <div className={'webchat_title'} >
              <div className="webchat_title_content">
                <span>Voice AI</span>
              </div>
              {features && features.includes('INCOMING_VOICE_ENABLED') &&
                <>
                {isSetupComplete ?
                  (<div className="webchat_title_action">
                  <div className="toggle-button">
                    <Toggle onClick={this.ToggleButton} data={toggle} />
                    <div className="toggle-data">
                      <div className={classnames('head', { 'disabled-webcaht ': !toggle })}>{this.ValueofToggle(toggle)}</div>
                      <div className="sub-head"> {this.ValueofSubheading(toggle)}</div>
                    </div>
                  </div>
                  </div>) : (
                    <div className="webchat_title_action">
                      <div className="toggle-button">
                          <div className="sub-head">Please contact the support team to complete the setup.</div>
                      </div>
                    </div>
                  )}
                  <div className='webchat_title_list'>
                    <Customization {...this.props} />
                  </div>
                </>}
              {showsucess &&
                <div className="copy-webhook">
                  <span className="tick-mark"><i className="material-icons">check</i></span>
                  Your changes have been saved.
                </div>
              }
              {showFailure &&
                <div className="copy-webhook-failure">
                  <span className="tick-mark">
                    <i className="material-icons">close</i>
                  </span>
                  Unable to update, please try again later.
                </div>
              }
            </div>
              {features && !features.includes('INCOMING_VOICE_ENABLED') &&
                <div className="form-response_campaign">
                  <div className="form-response_campaign_content">
                    <div className="upgrade-bar"> <a href="mailto:support@truelark.com">Upgrade </a>to enable Voice AI Feature</div>
                  </div>
                </div>}
          </>
        }
      </div>
    );
  }
}
export default VoiceAIConfig;
